import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int) {
        data: entry(section: "facultyIndex", siteId: $siteId, slug: $slug, draftId: $draftId, revisionId: $revisionId) {
            id
            status
            title
            ... on facultyIndex_Entry {
                seoMetaTitle
                seoMetaDescription
                userStatus
                directorsLabel
                body: html
                comingSoon: lightswitchDefaultOff
                showEmailForm: lightswitchDefaultOn
                singlesMatrix {
                    ... on pageTitle_Entry {
                        type: typeHandle
                        pageTitle
                    }
                    ... on html_Entry {
                        type: typeHandle
                        body
                        cssClasses
                        fullWidth
                    }
                    ... on body_Entry {
                        type: typeHandle
                        body
                        backgroundImage {
                            url
                        }
                        backgroundImageMobile {
                            url
                        }
                        bgMobileBreakpoint
                        backgroundColor
                        fullWidth
                        cssClasses
                    }
                    ... on ad_Entry {
                        type: typeHandle
                        ad
                    }
                    ... on emailForm_Entry {
                        type: typeHandle
                        textAbove
                    }
                    ... on programGuide2_Entry {
                        type: typeHandle
                        message
                        csvDownload
                        pdfDownload
                        programGuideSessionTypeTerm
                    }
                    ... on atAGlance_Entry {
                        type: typeHandle
                        message
                        atAGlanceEventTextColor
                    }
                    ... on directorsFaculty_Entry {
                        type: typeHandle
                        directorsHeading
                        rolesToSuppress
                    }
                    ... on faculty_Entry {
                        type: typeHandle
                        roles
                        restrictionStatuses
                        showFilters
                    }
                    ... on courseDirectors_Entry {
                        type: typeHandle
                        head
                        roles
                        rolesToSuppress
                        backgroundColor
                        highlightColor
                        fullWidth
                        layout
                        backgroundImage {
                            url
                        }
                    }
                    ... on customComponent_Entry {
                        type: typeHandle
                        component
                        customClass
                        json
                        contentBlox: contentBlocks {
                            ... on contentBlocksBlock_Entry {
                                block: contentBlock
                            }
                        }
                        parameters {
                            value
                        }
                    }
                }
            }
        }
    }
`
